<template>
  <div>
    <div
      class="d-flex flex-wrap flex-sm-nowrap align-center justify-end mb-4 gap-2"
    >
      <v-btn
        v-if="!hideRefresh"
        class="green-button text-white font-weight-bold text-body-2"
        :width="isMobile ? '100%' : 'auto'"
        @click="$emit('refresh')"
      >
        Actualizar
      </v-btn>

      <slot v-if="!isMobile && !isTablet" name="custom-message" />
      <v-fade-transition>
        <small v-if="message && !isMobile && !isTablet" class="ml-4">
          {{ message }}
        </small>
      </v-fade-transition>
      <v-spacer v-if="!isMobile" />

      <v-btn
        v-if="!hideExport"
        class="red-button text-white font-weight-bold text-body-2"
        :width="isMobile ? '100%' : 'auto'"
        :disabled="downloading"
        @click="$emit('export')"
      >
        {{ !downloading ? 'Exportar excel' : 'Exportando excel...' }}
      </v-btn>

      <boxed-switch
        v-if="!hideDelete"
        :value="deleteValue"
        :label="deleteTitle"
        :disabled="deleteDisabled"
        :width="isMobile ? '100%' : 'auto'"
        @input="(e) => $emit('update:delete', e)"
      />

      <search-input
        v-if="!hideSearch"
        :value="search"
        hide-details
        :default-width="!isMobile"
        :width="isMobile ? '100%' : 'auto'"
        @input="(e) => $emit('update:search', e)"
      />
    </div>

    <slot v-if="isMobile || isTablet" name="custom-message" />
    <v-fade-transition>
      <div v-if="message && (isMobile || isTablet)" class="w-100 text-right">
        <small>{{ message }}</small>
      </div>
    </v-fade-transition>
  </div>
</template>

<script>
  import BoxedSwitch from '../BoxedSwitch.vue';
  import SearchInput from '../SearchInput.vue';
  import screen from '@/mixins/screen';
  export default {
    name: 'TableToolbar',

    components: { BoxedSwitch, SearchInput },
    mixins: [screen],

    props: {
      message: {
        type: String,
        default: '',
      },

      deleteTitle: {
        type: String,
        default: 'Eliminar',
      },

      search: {
        type: String,
        required: true,
      },

      deleteValue: Boolean,
      deleteDisabled: Boolean,
      hideDelete: Boolean,
      hideRefresh: Boolean,
      hideSearch: Boolean,
      hideExport: Boolean,
      downloading: Boolean,
    },
  };
</script>
